import { FormFieldTypes } from '@App/enum/form-field-types'
import DropdownFormFieldProps from '@App/forms/v2/common/dropdown-form-field'
import CheckboxFormFieldProps from '@App/forms/v2/common/checkbox-form-field'
import DatePickerFormFieldProps from '@App/forms/v2/common/date-picker-form-field'
import { HTMLInputTypeAttribute, JSX } from 'react'
import { ZodTypeAny } from 'zod'
import { InternationalPhoneInputProps } from '@Fields/v2/InternationalPhoneInput'

interface FormFieldProps {
    name: string
    parentObjectName?: string
    label: string
    type: FormFieldTypes
    mainColor?: boolean
    assistiveText?: string
    assistiveTextFunction?: (props?: any) => string
    assistiveTextVisibility?: { errors?: boolean; assistive?: boolean }
    key?: string
    schema?: ZodTypeAny
    isDisabled?: boolean
    inputType?: HTMLInputTypeAttribute
    tooltip?: JSX.Element
    className?: string
    inputHeader?: JSX.Element
    validationDependency?: FormFieldProps[]
}

/**
 * FormFields and FormFieldType are generic types that allow for nested objects of
 * FormFields to exist within a whole FormFields object that is used in a form.
 * These objects are what the forms use to determine what values to use and
 * display.
 */
export type FormFields<T> = {
    [key in keyof Required<T>]: FormFieldType<T[key]>
}
export type FormFieldType<T> =
    | FormFieldProps
    | DropdownFormFieldProps
    | CheckboxFormFieldProps
    | DatePickerFormFieldProps
    | InternationalPhoneInputProps
    | FormFields<T>

export const isFormFieldProp = (value: FormFieldType<unknown>): value is FormFieldProps =>
    (value as FormFieldProps).type !== undefined

export const isFormFields = <T>(value: FormFieldType<T>): value is FormFields<T> =>
    (value as FormFieldProps).type === undefined

export default FormFieldProps
